var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default__wrapper"},[_c('nuxt',{staticClass:"default__nuxt"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }